module.exports = __webpack_public_path__ + "static/media/062-builder.fffaa902.svg";